<template>
  <div></div>
</template>

<script>
export default {
  name: 'DocumentList',
};
</script>
